import { render, staticRenderFns } from "./Pembatalan.vue?vue&type=template&id=7ab2b048&"
import script from "./Pembatalan.vue?vue&type=script&lang=js&"
export * from "./Pembatalan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports